export const ERRCODE_SUCCESS = 0

export enum ERRCODES_OTPCERTREQUEST {
  ErrorSpMember = 10220,
  Error30DaysLimit = 10221,
  Error5timesLimit = 10222,
  ErrorAlreadyMember = 10223,
  ErrorPNumber = 10050,
  ErrorNoTelecom = 10052,
  ErrorAuthMsgTime = 10053,
  ErrorInvalidAccessByRequestId = 10083,
  ErrorBlockedIp = 10084,
  ErrorLguPolicyBlocked = 10300,
  ErrorAge80Limit = 200008,
}

export enum ERRCODES_OTPCERTSUBMIT {
  ErrorAuthMsgNoRequest = 10060,
  ErrorAuthMsgNumberWrong = 10061,
  ErrorAuthMsgNumber3Wrong = 10062,
  ErrorTelecomServer = 10055,
}
